import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { numRegex } from "../../Const";
import { formatShortNumber, formatShortNumberTwo, maxAreaOption, maxOptions, minAreaOption, minOptions, onKeyDown } from "../CommonFun";
import Select from "react-select";

export default function DropdownInput({ title, plchdlr, bannerFilter, filterCallBack, minKey, maxKey }) {
    const [data, setData] = useState(plchdlr);
    const [selectOptions, setSelectOptions] = useState(bannerFilter);
    const [errorFlag, setErrorFlag] = useState({ text: "", valid: false });
    const [show, setShow] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const [minData, setMinData] = useState([]);
    const [maxData, setMaxData] = useState([]);
    useEffect(() => {
        if (title === "Price") {
            setMinData(minOptions);
            setMaxData(minOptions);
        } else if (title === "Area") {
            setMinData(minAreaOption);
            setMaxData(maxAreaOption);
        }
    }, [title]);
    useEffect(() => {
        setSelectOptions(bannerFilter);
    }, [bannerFilter]);

    const handlePriceChange = (e, kName) => {
        // e.preventDefault();
        // e.stopPropagation();
        setOpenMenu(null);
        let value;
        let name;
        if (kName) {
            value = e;
            name = kName;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        let option = { ...selectOptions };
        if (/^0/.test(value)) value = value.replace(/^0+/, "");
        if (numRegex.test(value)) {
            if (name === minKey) {
                if (value !== "") option[name] = value;
                else option[name] = "";
                setSelectOptions(option);
                // filterCallBack(option);
            } else if (name === maxKey) {
                option[name] = value;
                setSelectOptions(option);
            }
            if (option[minKey] && option[maxKey]) {
                const minPrice = parseInt(option[minKey]);
                const maxPrice = parseInt(option[maxKey]);
                if (minPrice > maxPrice) setErrorFlag({ text: `Maximum ${title.toLowerCase()} should be greater than minimum ${title.toLowerCase()}.`, valid: true });
                else {
                    filterCallBack(option);
                    setErrorFlag({ text: "", valid: false });
                }
            }
        }
    };
    const handleDone = () => {
        let minPce = selectOptions.minKey;
        let maxPce = selectOptions.maxKey;
        let value = minPce || maxPce ? `${formatShortNumber(minPce)}${maxPce ? ` - ${formatShortNumber(maxPce)}` : ""}` : plchdlr;
        setData(value);
    };
    const handleRemove = () => {
        let option = { ...selectOptions };
        option[minKey] = "";
        option[maxKey] = "";
        setSelectOptions(option);
        filterCallBack(option);
        setData(plchdlr);
        setErrorFlag({ text: "", valid: false });
    };

    return (
        <div className="filter-dropdown">
            <DropdownButton
                className="custom-dropdown dropdown-button"
                title={
                    selectOptions[minKey] || selectOptions[maxKey]
                        ? title === "Price"
                            ? selectOptions[minKey] && selectOptions[maxKey]
                                ? `${formatShortNumberTwo(selectOptions[minKey])} - ${formatShortNumberTwo(selectOptions[maxKey])} AED`
                                : formatShortNumberTwo(selectOptions[minKey])
                                ? `From ${formatShortNumberTwo(selectOptions[minKey])} AED`
                                : plchdlr
                            : title === "Area"
                            ? selectOptions[minKey] && selectOptions[maxKey]
                                ? `${formatShortNumber(selectOptions[minKey])} - ${formatShortNumber(selectOptions[maxKey])} sqft`
                                : formatShortNumber(selectOptions[minKey])
                                ? `From ${formatShortNumber(selectOptions[minKey])} sqft`
                                : plchdlr
                            : plchdlr
                        : data
                }
            >
                <div className="dropdown-grid dropdown-input">
                    <li className="mnly-item price-input-wrapper">
                        <label>Min</label>
                        <input
                            type="number"
                            className="dropdown-item"
                            name={[minKey]}
                            value={selectOptions[minKey]}
                            onKeyDown={onKeyDown}
                            onChange={handlePriceChange}
                            onClick={() => setOpenMenu(openMenu === "min" ? null : "min")}
                            placeholder={`Min. ${plchdlr}`}
                        />
                        <Select
                            classNamePrefix="custom-select"
                            options={minData}
                            name="minPrice"
                            value={minData.find((o) => o.value === Number(selectOptions[minKey])) || null}
                            onChange={(selected) => {
                                handlePriceChange(selected.value, minKey);
                                setOpenMenu(null);
                            }}
                            menuIsOpen={openMenu === "min"}
                            onMenuClose={() => setOpenMenu(null)}
                            styles={{
                                control: (base) => ({ ...base, display: "none" }),
                            }}
                        />
                        {/* <div className="error_head">
                            <div className="msg_error" aria-label="Error message">
                                <bdi>Minimum price should be less than maximum price.</bdi>
                            </div>
                            <bdi className="error_footer"></bdi>
                        </div> */}
                    </li>
                    <li className="mnly-item price-input-wrapper">
                        <label>Max</label>
                        <input
                            type="number"
                            className="dropdown-item"
                            name={maxKey}
                            value={selectOptions[maxKey]}
                            onKeyDown={onKeyDown}
                            onChange={handlePriceChange}
                            onClick={() => setOpenMenu(openMenu === "max" ? null : "max")}
                            placeholder={`Max. ${plchdlr}`}
                        />
                        <Select
                            classNamePrefix="custom-select"
                            options={maxData}
                            value={maxData.find((o) => o.value === Number(selectOptions[maxKey])) || null}
                            onChange={(selected) => {
                                handlePriceChange(selected.value, "maxPrice");
                                setOpenMenu(null);
                            }}
                            menuIsOpen={openMenu === "max"}
                            onMenuClose={() => setOpenMenu(null)}
                            styles={{
                                control: (base) => ({ ...base, display: "none" }),
                            }}
                        />
                        {errorFlag.valid && errorFlag.text && (
                            <div className="error_head">
                                <div className="msg_error" aria-label="Error message">
                                    <bdi>{errorFlag.text}</bdi>
                                </div>
                                <bdi className="error_footer"></bdi>
                            </div>
                        )}
                    </li>
                </div>
                <Dropdown.Item as="span" className="full-width">
                    <button
                        className="reset-button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleRemove();
                        }}
                    >
                        Reset
                    </button>
                    {(selectOptions?.minPrice || selectOptions?.maxPrice || selectOptions?.minArea || selectOptions?.maxArea) && !errorFlag.valid ? (
                        <button className="done-button" onClick={handleDone}>
                            Done
                        </button>
                    ) : (
                        <></>
                    )}
                </Dropdown.Item>
            </DropdownButton>
        </div>
    );
}
